import React from "react";
import "./AboutFeatureSection.css";

interface FeaturePoint {
  title: string;
  description?: string; // ✅ optional field
}

interface AboutFeatureSectionProps {
  tag: string;
  icon?: React.ReactNode;
  title: string;
  highlighted: string;
  description: string;
  points: FeaturePoint[]; // ✅ now array of objects
}

const AboutFeatureSection: React.FC<AboutFeatureSectionProps> = ({
  tag,
  icon,
  title,
  highlighted,
  description,
  points,
}) => {
  return (
    <div className="about-feature-section">
      <div className="feature-tag">
        {icon && <span className="feature-icon">{icon}</span>}
        <span>{tag}</span>
      </div>

      <h2
        className="feature-title"
        dangerouslySetInnerHTML={{
          __html: `${title} <strong>${highlighted}</strong>`,
        }}
      />

      <p>{description}</p>

      <ul className="feature-points">
        {points.map((point, i) => (
          <li key={i}>
            <div className="point-main">
              <i className="fa-solid fa-circle-check"></i>
              <span className="point-title">{point.title}</span>
            </div>
            {point.description && (
              <p className="point-description">{point.description}</p>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AboutFeatureSection;
